"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceLauncher = void 0;
const react_1 = __importStar(require("react"));
const uuid_1 = __importDefault(require("../utils/uuid"));
const AdsClick_1 = require("../Icons/AdsClick");
const Search_1 = require("../Icons/Search");
const SourceLauncher = ({ name, searchPlaceholder, icon, onBrowse, onSearch }) => {
    const [query, setQuery] = (0, react_1.useState)('');
    const [inputId] = (0, react_1.useState)((0, uuid_1.default)());
    const inputChangeHandler = (0, react_1.useCallback)((event) => {
        setQuery(event.target.value);
    }, []);
    const submitHandler = (0, react_1.useCallback)((event) => {
        event.preventDefault();
        onSearch(query);
    }, [query]);
    const searchHandler = (0, react_1.useCallback)(() => {
        onSearch(query);
    }, [query]);
    return (react_1.default.createElement("div", { className: "sourceLauncher" },
        react_1.default.createElement("form", { "aria-label": `search ${name} form`, onSubmit: submitHandler, className: "sourceLauncher__form" },
            react_1.default.createElement("label", { htmlFor: inputId, className: "sourceLauncher__title" },
                "Search ",
                name),
            react_1.default.createElement("div", { className: "sourceLauncher__input-group" },
                react_1.default.createElement("span", { className: "sourceLauncher__input-icon" }, icon),
                react_1.default.createElement("input", { id: inputId, placeholder: searchPlaceholder, onChange: inputChangeHandler, className: "sourceLauncher__input" }),
                react_1.default.createElement("button", { type: "button", "aria-label": "search", onClick: searchHandler, className: "sourceLauncher__search" },
                    react_1.default.createElement(Search_1.Search, { "aria-hidden": "true", className: "sourceLauncher__input-arrow" }))),
            react_1.default.createElement("div", { className: "sourceLauncher__browse-group" },
                react_1.default.createElement("span", { className: "sourceLauncher__or" }, "or"),
                react_1.default.createElement("button", { type: "button", onClick: onBrowse, className: "sourceLauncher__browse" },
                    react_1.default.createElement(AdsClick_1.AdsClick, { "aria-hidden": "true", className: "sourceLauncher__browse-icon" }),
                    "Browse")))));
};
exports.SourceLauncher = SourceLauncher;
